<template>
  <div class="order-analysis purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/client/orderMgmt' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">商品</span>
            <el-select v-model="params.productType" placeholder="请选择商品" size="small" filterable clearable class="filter-select-wide">
              <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">日期范围</span>
            <el-date-picker
              v-model="dateRange"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              class="filter-date-wide"
            />
          </div>
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="onQueryClick">分析</el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="onResetClick">重置</el-button>
            <el-button size="small" icon="el-icon-back" @click="goBack">返回订单管理</el-button>
          </div>
        </div>
        <div class="analysis-tip">
          按订单号去重后统计：同订单多行、唯一订单数量=1/2/3/4/5/&gt;5；并按收件地址/CPF 识别同一用户多次下单（需订单含地址信息）。
        </div>
      </div>
    </div>

    <div class="table-panel" v-loading="loading" element-loading-text="分析中...">
      <div class="summary-row">
        <div class="summary-card">
          <div class="summary-label">订单总数</div>
          <div class="summary-value">{{ result.totalOrderCount || 0 }}</div>
        </div>
        <div class="summary-card">
          <div class="summary-label">明细行数</div>
          <div class="summary-value">{{ result.totalLineCount || 0 }}</div>
        </div>
        <div class="summary-card accent-multi">
          <div class="summary-label">同订单号多行</div>
          <div class="summary-value">{{ multiLine.orderCount || 0 }}</div>
        </div>
        <div class="summary-card accent-eq1">
          <div class="summary-label">唯一订单 · 数量=1</div>
          <div class="summary-value">{{ uniqueQtyEq1.orderCount || 0 }}</div>
        </div>
        <div class="summary-card accent-gt1">
          <div class="summary-label">唯一订单 · 数量≥2</div>
          <div class="summary-value">{{ uniqueQtyGe2Count }}</div>
        </div>
        <div class="summary-card accent-repeat">
          <div class="summary-label">多次下单用户</div>
          <div class="summary-value">{{ repeatBuyers.userCount || 0 }}</div>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="analysis-tabs">
        <el-tab-pane :label="'同订单号多行（' + (multiLine.orderCount || 0) + '）'" name="multi">
          <div class="section-title">SKU 组合分布</div>
          <el-table :data="multiLine.combos || []" border stripe size="mini" max-height="260" empty-text="暂无该类型订单">
            <el-table-column label="序号" width="52" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="skuText" label="相关SKU组合" min-width="320" show-overflow-tooltip />
            <el-table-column prop="orderCount" label="订单数" width="90" align="right" />
            <el-table-column prop="quantity" label="数量合计" width="90" align="right" />
          </el-table>
          <div class="section-title">SKU 明细</div>
          <el-table :data="multiLine.skus || []" border stripe size="mini" max-height="320" empty-text="暂无该类型订单">
            <el-table-column label="序号" width="52" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="sku" label="SKU" min-width="200" show-overflow-tooltip />
            <el-table-column prop="productName" label="产品名称" width="120" show-overflow-tooltip />
            <el-table-column prop="productColorName" label="颜色" width="80" show-overflow-tooltip />
            <el-table-column prop="model" label="型号" width="100" show-overflow-tooltip />
            <el-table-column prop="asin" label="ASIN" width="120" show-overflow-tooltip />
            <el-table-column prop="orderCount" label="涉及订单数" width="100" align="right" />
            <el-table-column prop="quantity" label="数量合计" width="90" align="right" />
          </el-table>
        </el-tab-pane>

        <el-tab-pane v-for="item in uniqueQtyTabs" :key="item.name" :label="item.label + '（' + item.group.orderCount + '）'" :name="item.name">
          <div class="section-title">相关 SKU</div>
          <el-table :data="item.group.skus || []" border stripe size="mini" max-height="420" empty-text="暂无该类型订单">
            <el-table-column label="序号" width="52" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="sku" label="SKU" min-width="200" show-overflow-tooltip />
            <el-table-column prop="productName" label="产品名称" width="120" show-overflow-tooltip />
            <el-table-column prop="productColorName" label="颜色" width="80" show-overflow-tooltip />
            <el-table-column prop="model" label="型号" width="100" show-overflow-tooltip />
            <el-table-column prop="asin" label="ASIN" width="120" show-overflow-tooltip />
            <el-table-column prop="orderCount" label="订单数" width="90" align="right" />
            <el-table-column prop="quantity" label="数量合计" width="90" align="right" />
          </el-table>
        </el-tab-pane>

        <el-tab-pane :label="'同一用户多次下单（' + (repeatBuyers.userCount || 0) + '）'" name="repeat">
          <div class="section-title">多次下单用户（{{ repeatBuyers.userCount || 0 }} 人 / {{ repeatBuyers.orderCount || 0 }} 单）</div>
          <el-table
            :data="repeatBuyers.list || []"
            border
            stripe
            size="mini"
            max-height="560"
            row-key="userKey"
            empty-text="暂无同一用户多次下单数据（订单需含收件地址或 CPF）"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="repeat-order-box">
                  <div class="repeat-order-title">订单列表（按时间升序）</div>
                  <el-table :data="scope.row.orders || []" border size="mini" class="repeat-order-table">
                    <el-table-column label="序号" width="50" align="center">
                      <template slot-scope="orderScope">{{ orderScope.$index + 1 }}</template>
                    </el-table-column>
                    <el-table-column prop="purchaseTime" label="下单时间" width="160" show-overflow-tooltip />
                    <el-table-column prop="orderId" label="订单号" min-width="160" show-overflow-tooltip>
                      <template slot-scope="orderScope">
                        <span class="mono-text">{{ orderScope.row.orderId || "—" }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单状态" width="100" align="center">
                      <template slot-scope="orderScope">
                        <el-tag size="mini" :type="getOrderStatusType(orderScope.row.orderStatus)" effect="light">
                          {{ getOrderStatusName(orderScope.row.orderStatus) }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="数量" width="70" align="right" />
                    <el-table-column label="SKU" min-width="220" show-overflow-tooltip>
                      <template slot-scope="orderScope">{{ (orderScope.row.skus || []).join("、") || "—" }}</template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="序号" width="52" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="userLabel" label="用户标识（地址/CPF）" min-width="260" show-overflow-tooltip />
            <el-table-column prop="orderCount" label="下单次数" width="90" align="right" />
            <el-table-column prop="quantity" label="数量合计" width="90" align="right" />
            <el-table-column label="最近下单" width="160" show-overflow-tooltip>
              <template slot-scope="scope">{{ getLatestOrderTime(scope.row) }}</template>
            </el-table-column>
            <el-table-column label="订单状态概览" min-width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ getOrderStatusSummary(scope.row) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts } from "../../utils/constant.js";

const EMPTY_GROUP = { orderCount: 0, skus: [], combos: [] };
const EMPTY_REPEAT = { userCount: 0, orderCount: 0, list: [] };

function createEmptyResult() {
  return {
    totalOrderCount: 0,
    totalLineCount: 0,
    multiLineOrder: { ...EMPTY_GROUP },
    uniqueQtyEq1: { ...EMPTY_GROUP },
    uniqueQtyEq2: { ...EMPTY_GROUP },
    uniqueQtyEq3: { ...EMPTY_GROUP },
    uniqueQtyEq4: { ...EMPTY_GROUP },
    uniqueQtyEq5: { ...EMPTY_GROUP },
    uniqueQtyGt5: { ...EMPTY_GROUP },
    repeatBuyers: { ...EMPTY_REPEAT },
  };
}

function buildRecentDaysRange(dayCount) {
  const end = new Date();
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);
  start.setDate(end.getDate() - (dayCount - 1));
  return [start, end];
}

function buildDatePickerOptions() {
  return {
    shortcuts: [
      {
        text: "今天",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(1));
        },
      },
      {
        text: "近7天",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(7));
        },
      },
      {
        text: "近30天",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(30));
        },
      },
      {
        text: "本月",
        onClick(picker) {
          const end = new Date();
          const start = new Date(end.getFullYear(), end.getMonth(), 1);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "上个月",
        onClick(picker) {
          const now = new Date();
          const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          const end = new Date(now.getFullYear(), now.getMonth(), 0);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "近90天",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(90));
        },
      },
      {
        text: "近180天",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(180));
        },
      },
      {
        text: "近1年",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(365));
        },
      },
      {
        text: "近5年",
        onClick(picker) {
          picker.$emit("pick", buildRecentDaysRange(365 * 5));
        },
      },
    ],
  };
}

export default {
  name: "OrderAnalysis",
  data() {
    return {
      productList: activeProducts,
      dateRange: [],
      params: {
        productType: "",
      },
      loading: false,
      activeTab: "multi",
      result: createEmptyResult(),
      pickerOptions: buildDatePickerOptions(),
    };
  },
  computed: {
    multiLine() {
      return this.result.multiLineOrder || EMPTY_GROUP;
    },
    uniqueQtyEq1() {
      return this.result.uniqueQtyEq1 || EMPTY_GROUP;
    },
    uniqueQtyEq2() {
      return this.result.uniqueQtyEq2 || EMPTY_GROUP;
    },
    uniqueQtyEq3() {
      return this.result.uniqueQtyEq3 || EMPTY_GROUP;
    },
    uniqueQtyEq4() {
      return this.result.uniqueQtyEq4 || EMPTY_GROUP;
    },
    uniqueQtyEq5() {
      return this.result.uniqueQtyEq5 || EMPTY_GROUP;
    },
    uniqueQtyGt5() {
      return this.result.uniqueQtyGt5 || EMPTY_GROUP;
    },
    uniqueQtyGe2Count() {
      return (
        (this.uniqueQtyEq2.orderCount || 0) +
        (this.uniqueQtyEq3.orderCount || 0) +
        (this.uniqueQtyEq4.orderCount || 0) +
        (this.uniqueQtyEq5.orderCount || 0) +
        (this.uniqueQtyGt5.orderCount || 0)
      );
    },
    uniqueQtyTabs() {
      return [
        { name: "eq1", label: "唯一订单号 · 数量=1", group: this.uniqueQtyEq1 },
        { name: "eq2", label: "唯一订单号 · 数量=2", group: this.uniqueQtyEq2 },
        { name: "eq3", label: "唯一订单号 · 数量=3", group: this.uniqueQtyEq3 },
        { name: "eq4", label: "唯一订单号 · 数量=4", group: this.uniqueQtyEq4 },
        { name: "eq5", label: "唯一订单号 · 数量=5", group: this.uniqueQtyEq5 },
        { name: "gt5", label: "唯一订单号 · 数量>5", group: this.uniqueQtyGt5 },
      ];
    },
    repeatBuyers() {
      return this.result.repeatBuyers || EMPTY_REPEAT;
    },
  },
  mounted() {
    this.initDefaultDateRange();
    const query = this.$route.query || {};
    if (query.productType) {
      this.params.productType = Number(query.productType) || query.productType;
    }
  },
  methods: {
    initDefaultDateRange() {
      const end = new Date();
      const start = new Date();
      start.setDate(end.getDate() - 6);
      this.dateRange = [start.format("yyyy-MM-dd"), end.format("yyyy-MM-dd")];
    },
    goBack() {
      this.$router.push("/client/orderMgmt");
    },
    getOrderStatusName(status) {
      const statusMap = {
        Unshipped: "未发货",
        Shipped: "已发货",
        Cancelled: "已取消",
        Pending: "待处理",
      };
      return statusMap[status] || status || "—";
    },
    getOrderStatusType(status) {
      if (status === "Shipped") {
        return "success";
      }
      if (status === "Unshipped" || status === "Pending") {
        return "warning";
      }
      if (status === "Cancelled") {
        return "info";
      }
      return "";
    },
    getLatestOrderTime(row) {
      const orders = row.orders || [];
      if (!orders.length) {
        return "—";
      }
      return orders[orders.length - 1].purchaseTime || "—";
    },
    getOrderStatusSummary(row) {
      const counter = {};
      (row.orders || []).forEach(order => {
        const name = this.getOrderStatusName(order.orderStatus);
        counter[name] = (counter[name] || 0) + 1;
      });
      return (
        Object.keys(counter)
          .map(name => name + " " + counter[name])
          .join(" / ") || "—"
      );
    },
    onResetClick() {
      this.params.productType = "";
      this.initDefaultDateRange();
      this.result = createEmptyResult();
      this.activeTab = "multi";
    },
    onQueryClick() {
      if (!this.params.productType) {
        this.$message.warning("请选择商品");
        return;
      }
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning("请选择日期范围");
        return;
      }
      this.loading = true;
      requestModules
        .analyzeOrders({
          productType: this.params.productType,
          beginDate: this.dateRange[0],
          endDate: this.dateRange[1],
        })
        .then(res => {
          if (res.code !== 0) {
            this.$message.error((res && res.message) || "分析失败");
            return;
          }
          const mdata = res.mdata || {};
          this.result = {
            totalOrderCount: mdata.totalOrderCount || 0,
            totalLineCount: mdata.totalLineCount || 0,
            multiLineOrder: mdata.multiLineOrder || { ...EMPTY_GROUP },
            uniqueQtyEq1: mdata.uniqueQtyEq1 || { ...EMPTY_GROUP },
            uniqueQtyEq2: mdata.uniqueQtyEq2 || { ...EMPTY_GROUP },
            uniqueQtyEq3: mdata.uniqueQtyEq3 || { ...EMPTY_GROUP },
            uniqueQtyEq4: mdata.uniqueQtyEq4 || { ...EMPTY_GROUP },
            uniqueQtyEq5: mdata.uniqueQtyEq5 || { ...EMPTY_GROUP },
            uniqueQtyGt5: mdata.uniqueQtyGt5 || { ...EMPTY_GROUP },
            repeatBuyers: mdata.repeatBuyers || { ...EMPTY_REPEAT },
          };
        })
        .catch(() => {
          this.$message.error("分析失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.order-analysis {
  .breadcrumb-box {
    flex-shrink: 0;
    padding: 0 4px 10px;
  }

  .filter-date-wide {
    width: 280px !important;
  }

  .analysis-tip {
    margin-top: 4px;
    margin-bottom: 2px;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }

  .summary-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 14px;
  }

  .summary-card {
    min-width: 120px;
    flex: 1;
    padding: 12px 14px;
    background: #f7f8fa;
    border: 1px solid #ebeef5;
    border-radius: 8px;

    .summary-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 6px;
    }

    .summary-value {
      font-size: 22px;
      font-weight: 600;
      color: #303133;
      font-variant-numeric: tabular-nums;
    }

    &.accent-multi {
      background: #ecf5ff;
      border-color: #d9ecff;
      .summary-value {
        color: #409eff;
      }
    }

    &.accent-gt1 {
      background: #fdf6ec;
      border-color: #faecd8;
      .summary-value {
        color: #e6a23c;
      }
    }

    &.accent-eq1 {
      background: #f0f9eb;
      border-color: #e1f3d8;
      .summary-value {
        color: #67c23a;
      }
    }

    &.accent-repeat {
      background: #f4ecff;
      border-color: #e9d7ff;
      .summary-value {
        color: #9b59b6;
      }
    }
  }

  .analysis-tabs {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .el-tabs__header {
      flex-shrink: 0;
    }

    .el-tabs__content {
      flex: 1;
      min-height: 0;
      overflow: auto;
    }
  }

  .section-title {
    margin: 12px 0 8px;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;

    &:first-child {
      margin-top: 0;
    }
  }

  .table-panel {
    overflow: auto;
  }

  .mono-text {
    font-family: Consolas, Menlo, Monaco, monospace;
    font-size: 12px;
  }

  .repeat-order-box {
    padding: 8px 12px 12px 36px;
    background: #fafafa;
  }

  .repeat-order-title {
    margin-bottom: 8px;
    font-size: 12px;
    color: #606266;
    font-weight: 600;
  }

  .repeat-order-table {
    background: #fff;
  }
}
</style>
